import { NamedItemInt } from '../../domain/common/namedItem'
import { RecurringExpenseFrequency } from '../../domain/expenses/ReccuringExpenseFrequency'
import { RecurringExpenseStatus } from '../../domain/expenses/RecurringExpenseStatus'
import { adminHttpClient } from '../commons/adminHttpClient'
import PagedList from '../commons/pagedList'

export interface PriorRecurringExpenseResponse {
  recurringExpenseId: string
  policyName: string
  expenseType: NamedItemInt
  approvedAmount: number
  approvedFrequency: RecurringExpenseFrequency
  approvedStartDate: string
  approvedEndDate: string
  status: RecurringExpenseStatus
  isDuplicate: boolean
  matchCount: number
  attachments: Attachment[]
}

type Attachment = {
  attachmentId: string
  fileNameUrl: string
  title: string
  reuseInOtherExpenses: boolean
}

export const getPriorPremiums = (
  currentRecurringExpenseId: string,
  pageNumber: number,
): Promise<PagedList<PriorRecurringExpenseResponse>> => {
  return adminHttpClient.get(`/Expenses/PriorRecurringExpenses/${currentRecurringExpenseId}`, { pageNumber })
}
